// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7cca58e","453":"3c2986fb","455":"91859bb2","977":"da465b0d"}[chunkId] + ".chunk.js";
};